export default __webpack_public_path__ + "static/media/mobile_banner_home.6bfb6e06.jpg";